export const isAuditor = () => {
  try {
    return JSON.parse(localStorage.getItem("mspUser"));
  } catch (error) {
    console.error("Error parsing wafrOnly from localStorage:", error);
    return false; // Return a default boolean value
  }
};
